import { z } from 'zod';

/**
 * The chat card for a playbook the AI is generating, optionally from one or
 * more documents.
 *
 * Carries the generation job rather than a playbook because there is no
 * playbook yet: the job writes it only once the model has answered, minutes
 * after the card is emitted. The card follows the job and picks the playbook
 * up when it lands. `documentIds` is empty when the playbook is generated
 * from intake alone.
 */
export const PlaybookAiGenerationResultSchema = z.object({
  documentIds: z.array(z.uuid()),
  generationJobId: z.uuid(),
  playbookGenerationCardId: z.string().min(1),
  type: z.literal('playbook-generation'),
});
export type PlaybookAiGenerationResult = z.infer<typeof PlaybookAiGenerationResultSchema>;

/** The chat card for a playbook run started against a document. */
export const PlaybookAiRunResultSchema = z.object({
  documentId: z.uuid(),
  playbookId: z.uuid(),
  playbookRunCardId: z.string().min(1),
  type: z.literal('playbook-run'),
});
export type PlaybookAiRunResult = z.infer<typeof PlaybookAiRunResultSchema>;
